var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31.5V19.502",
    stroke: "#A8ACB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0078 24.5011L16.0036 19.502L20.9994 24.5011",
    stroke: "#A8ACB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9953 21.4976H24.494C27.2903 21.5023 29.7757 19.7155 30.6635 17.0621C31.5514 14.4087 30.6423 11.4846 28.407 9.80344C26.1716 8.1223 23.1119 8.06165 20.8118 9.65288C19.8846 4.71284 15.4364 1.22959 10.4216 1.51651C5.40671 1.80343 1.3843 5.77131 1.02578 10.7849C0.667268 15.7985 4.08412 20.2991 9.00705 21.2976",
    stroke: "#A8ACB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.6cb185f1e842ac3c0d8452d73c5fd72f.svg";
export { ForwardRef as ReactComponent };